module.exports = __webpack_public_path__ + "img/apple-ios.bbb06c48.png";